import { RegistrantFilter } from '@/types/registration.types';
import Container from '@ui/container/container';
import Icon from '@ui/icons/icon';
import Text from '@ui/text/text/text';
import { ICONS } from '@ui/icons/types';
import classNames from 'classnames';
import { NavLink, useParams } from 'react-router-dom';
import styles from '../passcode-lists/add-new-passcode-list-card.module.css';
import { TGlobalContainerDesigns } from '@styles/design-system/global-components/global-components.types';

type RegistrantFilterCardProps = {
  filter: RegistrantFilter;
};

const RegistrantFilterCard = ({ filter }: RegistrantFilterCardProps) => {
  const { projectUuid, language } = useParams();

  return (
    <NavLink
      to={`/project/edit/${projectUuid}/${language}/audiences/registrants?status=${filter.type}`}
      className={classNames(styles['passcode-list-edit'])}
      style={{ textDecoration: 'none' }}
    >
      <Container
        height="180px"
        width="320px"
        design={TGlobalContainerDesigns.GlobalCont1}
        className={classNames('padding-h-20 padding-b-20 flex fd-column jc-space-between radius-16')}
      >
        <Container className="flex fd-row jc-space-between" height="125px">
          <Text tag="h5" clamp={5} className="H5 padding-t-20">
            {filter.name}
          </Text>
        </Container>
        <Container
          background="rgba(var(--primitives-mode-1-gray-1200-rgb), 0.2)"
          padding="8px 10px"
          className="flex fd-row jc-flex-end radius-8"
          style={{ lineHeight: '13px', alignSelf: 'flex-end' }}
        >
          <Icon name={ICONS.PEOPLE_NAV} size={13} color="var(--gray-100)" />
          <Text fontSize={'13px'} className="margin-l-4">
            {filter.member_count}
          </Text>
        </Container>
      </Container>
    </NavLink>
  );
};

export default RegistrantFilterCard;
